/**
 * Text properties supported by TextControlGroup
 * Import this from @wix/editor-elements-panel-service' cause 2mb bundle size increase ¯\_(ツ)_/¯
 */
export const TEXT_PROPERTIES = [
  'color',
  'textDecorationLine',
  'textDirection',
  'font',
  'fontFamily',
  'fontWeight',
  'fontStyle',
  'fontSize',
  'textAlign',
  'textTransform',
  'lineHeight',
  'letterSpacing',
  'textShadow',
  'listStyle',
  'indent',
  'writingMode',
  'a11y',
];
